export default "__VITE_ASSET__ba9ba75e__"